import React from "react";
import { convertUtcToLocalTime } from "./DateFormating";
interface StatusProps {
  isActive: boolean;
  isActiveLabel?: string;
  isInactiveLabel?: string;
  ts?: Date | string;
  tsLabel?: string;
}

export const Status = ({
  isActive = false,
  isActiveLabel,
  isInactiveLabel,
  ts,
  tsLabel,
}: StatusProps) => {
  return (
    <div className="flex items-center space-x-4 w-full max-w-md my-3">
      <div className="flex items-center">
        {isActive ? (
          <div
            className="ml-2 h-2 w-2 rounded-full bg-green-600 animate-pulse shadow-lg"
            style={{
              boxShadow: "0 0 0 0 #69ffa8",
              animation: "pulse 1.5s infinite ease-in-out",
            }}
          ></div>
        ) : (
          <div
            className="ml-2 h-2 w-2 rounded-full bg-red-400 shadow-lg"
            style={{
              boxShadow: "0 0 0 0 #69ffa8",
            }}
          ></div>
        )}
        {isActiveLabel && isInactiveLabel && (
          <p className="ml-2">{isActive ? isActiveLabel : isInactiveLabel}</p>
        )}
      </div>
      <div className="leading-none">
        {ts && <p className="text-xl text">{convertUtcToLocalTime(ts)}</p>}
        {ts && tsLabel && <p className="ml-0.5">{tsLabel}</p>}
      </div>
    </div>
  );
};

export const LoadingSpinner: React.FC<{ message?: string }> = ({
  message = "Loading...",
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-center p-4 m-4 bg-blue-50 rounded-lg max-w-full mx-auto sm:max-w-md">
      <div className="animate-spin h-8 w-8 sm:h-6 sm:w-6 mb-2 sm:mb-0 sm:mr-3 border-t-2 border-blue-500 rounded-full"></div>
      <span className="text-blue-800 text-center text-base sm:text-sm font-medium">
        {message}
      </span>
    </div>
  );
};

export const ErrorDisplay: React.FC<{ message?: string }> = ({
  message = "Something went wrong. Please try again later.",
}) => {
  return (
    <div className="p-4 m-4 bg-red-50 border border-red-200 rounded-lg text-red-800 max-w-full mx-auto sm:max-w-md">
      <p className="text-center sm:text-left text-base font-semibold">{`⚠️ ${message}`}</p>
    </div>
  );
};
